import React, { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Flex, Container, Square } from '@grubhubprod/gh-cookbook-react/dist';
import classnames from 'classnames';
import { getWindow } from 'src/utilities/window';

export const MODAL_ROOT_ID = 'modal-root';
export const MODAL_Z_INDEX = 1032;

interface IModalProps {
  children: ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'default' | 'fluid';
  modalWidth?: string;
}

export function Modal({
  children,
  size = 'default',
  modalWidth,
}: IModalProps): JSX.Element {
  const window = getWindow();
  const modalRoot = window.document.getElementById(MODAL_ROOT_ID);

  if (modalRoot) {
    return createPortal(
      <Flex
        data-testid="modal-backdrop"
        bg="globals.stone90a"
        alignItems="center"
        justifyContent="center"
        position="fixed"
        top="0"
        bottom="0"
        left="0"
        right="0"
        zIndex={MODAL_Z_INDEX} // Need to be over popover (1031)
      >
        <Container
          variant={size}
          className={classnames('modalContent', {
            hasCustomWidth: !!modalWidth,
          })}
        >
          <Square
            borderRadius="3px"
            bg="untintedBackground"
            width={modalWidth || '100%'}
          >
            {children}
          </Square>
        </Container>
      </Flex>,
      modalRoot
    );
  }

  return null;
}
